import { BorderRadius, Color, FontSize, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface CarouselWidgetContainerProps {
  backgroundColor?: string
}

export const CarouselWidgetContainer = styled.div<CarouselWidgetContainerProps>`
  display: flex;
  gap: ${Spacing.S12};
  width: 100%;
  height: 270px;
  padding: ${Spacing.S24} ${Spacing.S24} ${Spacing.S32};
  border-radius: ${BorderRadius.R12};
  background-color: ${({ backgroundColor }) => backgroundColor ?? Color.White};
  box-shadow: 0 2px 1px ${Color.Grey150};
  text-align: left;
`

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 66%;
  height: 100%;
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33%;
`

export const Description = styled.p`
  color: ${Color.Black};
  font-size: ${FontSize.TextBodyMD};
  line-height: 18px;
`

export const Illustration = styled.img`
  width: 70%;
  min-width: 150px;
  height: 70%;
  min-height: 150px;
`
